<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
/**
 * Basic-table component
 */
export default {
  components: {ErrorMessage, Layout, PageHeader },
  data() {
    return {
      title: "Approved Agent List",
      items: [
        {
          text: "Agent",
          href: "/",
        },
        {
          text: "Agent List",
          active: true,
        },
      ],
      agents: [],
        agent:[],
        agency:[],
        user:[],
        errors:null,
        visible:false,
        message:"",
        search_fname:"",
        search_lname:"",
        search_uname:"",
        search_email:"",
        search_phone:"",
        search_pcode:"",
        search_currency:"",
        search_balance:"",
        search:"",
    };
  },
  mounted() {
    this.getAgentList();
  },
    computed: {
        filteredList() {
            return this.agents.filter(agent => {
                return (agent.users[0].username==null ? '' : agent.users[0].username).toLowerCase().includes(this.search_uname.toLowerCase())
                    && agent.email.toLowerCase().includes(this.search_email.toLowerCase())
            })
        }
    },

    methods: {
      onClose(){
          this.visible=false;
      },
        searchFilterFunc2(val) {
            this.search=val;
        },
        onClick(link){
            window.open(link);
        },
        async userStatusWarning(id) {
            var _this = this;
            try {
                this.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Change status!",
                    cancelButtonText: "No",
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                }).then((result) => {
                    if (result.value) {
                        _this.userStatus(id);
                    } else {
                        this.$swal("Cancelled", "", "info");
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
        async userStatus(id) {
            try {
                axios
                    .post("/api/user/b2c/status/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.status=response.data.data.status;
                            this.$swal("Status Changed Successfully");
                            this.getAgentList();
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },

        async getAgentDetails(agent){
            var _this = this;
          let uuid=agent.uuid;
          try{
              axios
                  .post("/api/agent/detail/" + uuid, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.agent=response.data.data.data;
                          this.agency=response.data.data.data.agency_information[0];
                          this.user=response.data.data.data.users[0];
                      }else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          _this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    async deleteWarning(agent) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(agent);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getAgentList() {
      try {
        axios
          .get("/api/agent/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              let agents = response.data.data;
              let filteredAgent=[];
              let i;
              for(i=0;i<agents.length;i++){
                  if(agents[i].approval_status== 'approved'){
                      filteredAgent.push(agents[i]);
                  }
              }
              this.agents=filteredAgent;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },

    deleteItem: function deleteItem(agent) {
      var _this = this;
      axios
        .post("/api/agent/delete/" + agent.uuid, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
            if(response.data.status){
                _this.getAgentList();
                _this.hasDeleted = false;
            } else {
                var str = response.data.message;
                var jsonParse = JSON.parse(str);
                _this.errorCheck(jsonParse);
            }
        });
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-modal
                  id="modal-lg"
                  size="lg"
                  title="Agent Details"
                  title-class="font-18"
                  hide-footer
              >
                  <div class="padding-5px">
                  <div v-if="agency!=undefined">
                      <h4>Agency Information</h4>
                      <table class="table-responsive">
                          <tr>
                              <td><img v-bind:src="agency.agency_logo" alt="logo"></td>

                          </tr>
                          <tr>
                              <td>Name</td>
                              <td v-if="agency.agency_name != null">{{agency.agency_name}}</td>
                              <td>Civil Aviation Certificate No.</td>
                              <td v-if="agency.civil_aviation_certificate_no != null">{{agency.civil_aviation_certificate_no}}</td><td v-else> N/A</td>

                          </tr>
                          <tr>
                              <td>Iata No.</td>
                              <td v-if="agency.iata_no != null">{{agency.iata_no}}</td><td v-else> N/A</td>
                              <td>Civil Aviation Certificate</td>
                              <td v-if="agency.civil_aviation_certificate_document != null">
                                  <button class="btn btn-link" @click.prevent="onClick(agency.civil_aviation_certificate_document)">download</button>
                              </td>
                              <td v-else>
                                  N/A
                              </td>


                          </tr>
                          <tr>
                              <td>Trade Licence No.</td>
                              <td v-if="agency.trade_license_no !=null">{{agency.trade_license_no}}</td>
                              <td v-else>
                                  N/A
                              </td>
                              <td>Management Full Name</td>
                              <td v-if="agency.management_full_name != null">{{agency.management_full_name}}</td>
                              <td v-else>
                                  N/A
                              </td>

                          </tr>
                          <tr>

                              <td>Postal Code</td>
                              <td v-if="agency.postal_code != null">{{agency.postal_code}}</td><td v-else> N/A</td>
                              <td>Management Ownership Title</td>
                              <td v-if="agency.management_ownership_title != null">{{agency.management_ownership_title}}</td><td v-else> N/A</td>

                          </tr>
                          <tr>

                              <td>Address</td>
                              <td v-if="agency.address != null">{{agency.address}}</td><td v-else>N/A</td>
                              <td>Management Phone No.</td>
                              <td v-if="agency.management_phone_number != null">{{agency.management_phone_number}}</td><td v-else>N/A</td>
                          </tr>
                          <tr>
                              <td>Website</td>
                              <td v-if="agency.website != null">{{agency.website}}</td><td v-else>N/A</td>
                              <td>Management Email</td>
                              <td v-if="agency.management_email != null">{{agency.management_email}}</td><td v-else>N/A</td>

                          </tr>
                          <tr>
                              <td>Fax</td>
                              <td v-if="agency.fax_no != null">{{agency.fax_no}}</td><td v-else>N/A</td>
                              <td>Contact Person Full Name</td>
                              <td v-if="agency.contact_person_full_name != null">{{agency.contact_person_full_name}}</td><td v-else>N/A</td>

                          </tr>
                          <tr>
                              <td>City</td>
                              <td v-if="agency.city != null">{{agency.city}}</td><td v-else>N/A</td>
                              <td>Contact Person Email</td>
                              <td v-if="agency.contact_person_email != null">{{agency.contact_person_email}}</td><td v-else>N/A</td>
                          </tr>
                          <tr>

                              <td>Country</td>
                              <td v-if="agency.country != null">{{agency.country}}</td><td v-else>N/A</td>
                              <td>Contact Person Phone No.</td>
                              <td v-if="agency.contact_person_phone_number != null">{{agency.contact_person_phone_number}}</td><td v-else>N/A</td>

                          </tr>
                          <tr>

                          </tr>
                          <tr>

                          </tr>

                      </table>
                  </div>
                      <div v-else>
                          <h4>Agency Info Not Available</h4>
                      </div>
                  <div>
                      <h4>Agent Information</h4>
                      <table class="table-responsive">
                          <tr>
                              <td>First Name</td>
                              <td>{{agent.first_name}}</td>

                              <td>Country Code</td>
                              <td>{{agent.country_code}}</td>
                          </tr>
                          <tr>
                              <td>Last Name</td>
                              <td>{{agent.last_name}}</td>

                              <td>Country</td>
                              <td>{{agent.country}}</td>
                          </tr>
                          <tr>
                              <td>Email</td>
                              <td>{{agent.email}}</td>

                              <td>Currency</td>
                              <td>{{agent.currency}}</td>
                          </tr>
                          <tr>
                              <td>Phone No</td>
                              <td>{{agent.phone_code}}{{agent.phone_number}}</td>

                              <td>City</td>
                              <td>{{agent.city}}</td>
                          </tr>
                          <tr>
                              <td>Gender</td>
                              <td>{{agent.gender}}</td>

                              <td>Markup Amount</td>
                              <td>{{agent.markup_amount}}</td>
                          </tr>
                          <tr>
                              <td>Postal Code</td>
                              <td>{{agent.postal_code}}</td>

                              <td>Markup Type</td>
                              <td>{{agent.markup_type}}</td>
                          </tr>
                          <tr>
                              <td>Language</td>
                              <td>{{agent.language}}</td>
                          </tr>
                      </table>
                  </div>
                  <div>
                      <h4>User Information</h4>
                      <table class="table-responsive">
                          <tr>
                              <td>First Name</td>
                              <td>{{user.first_name}}</td>

                              <td>Display Picture</td>
                              <td><img class="width-20px" v-bind:src="user.display_picture" alt="Picture"></td>
                          </tr>
                          <tr>
                              <td>Last Name</td>
                              <td>{{user.last_name}}</td>

                              <td>Country Code</td>
                              <td>{{user.country_code}}</td>
                          </tr>
                          <tr>
                              <td>Email</td>
                              <td>{{user.email}}</td>

                              <td>Country</td>
                              <td>{{user.country}}</td>
                          </tr>
                          <tr>
                              <td>Phone No</td>
                              <td>{{user.phone_code}}{{user.phone_number}}</td>

                              <td>Account Status</td>
                              <td>{{user.status}}</td>
                          </tr>
                          <tr>
                              <td>Gender</td>
                              <td>{{user.gender}}</td>
                          </tr>
                      </table>
                  </div>
                  </div>
              </b-modal>
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>Agent ID</th>
                    <th>
                        <div class="row">
                            <div class="col-xs-4">Login ID</div>
                        </div>
                        <div class="row">
                            <div class="col-xs-4">Company Name/Balance/loan</div>
                        </div>
                    </th>
                    <th>User/Contact Info </th>
                      <th>Owner Info</th>
                    <th>
                        <div class="row">
                            <div class="col-xs-4">City</div>
                        </div>
                        <div class="row">
                            <div class="col-xs-4">State/Country</div>
                        </div>

                    </th>
                    <th>Action</th>
<!--                      <th>Currency</th>-->
<!--                      <th>Language</th>-->
<!--                      <th>Balance</th>-->
<!--                      <th>Loan</th>-->
<!--                      <th>Status</th>-->
<!--                      <th></th>-->
<!--                    <th>Action</th>-->
<!--                      <th></th>-->
                  </tr>
                  <tr>
                    <td> <input type="text" class="app-search form-control" v-model="search_uname" placeholder="Search id" /></td>
                    <td><input type="text" class="app-search form-control" v-model="search_email" placeholder="Search email / agency Name" /></td>
<!--                    <td><input type="text" class="app-search form-control" v-model="search_phone" placeholder="Search " /></td>-->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(agent,index) in filteredList" v-bind:key="index">
<!--                    <th scope="row">{{agent.new_index}}</th>-->
<!--                    <td>{{agent.first_name}}</td>-->
<!--                    <td>{{agent.last_name}}</td>-->
                      <td v-if="agent.users!=undefined"><router-link  :to="{ name: 'admin_agent_details', params: {id: agent.users[0].id } }" target="_blank" >{{agent.users[0].username==null ? 'N/A' :agent.users[0].username}}</router-link> <i v-if="agent.users[0].status=='active'" class="bx bx-check"></i> <i v-else class="bx bx-x"></i>{{agent.users[0].status}}</td>
                      <td v-else>null</td>
                    <td class="padding-5px-right" v-if="agent.agency_information[0]!=undefined">
                        <div class="row">
                            <div class="col-xs-4">{{agent.email}}</div>
                        </div>
                        <div class="row">
                            <div class="col-xs-4"> {{agent.agency_information[0].agency_name}}</div>
                        </div>
                        <div class="row">
                            <div class="col-xs-4"> <b-badge variant="success" class="ml-1">{{ agent.users[0].user_wallet!=null ? agent.users[0].user_wallet.currency : 'N/A' }}</b-badge>  <b-badge variant="success" class="ml-1">{{ agent.users[0].user_wallet!=null ? agent.users[0].user_wallet.main_balance : 'N/A' }}</b-badge> <b-badge variant="danger" class="ml-1">{{agent.users[0].user_wallet!=null ? agent.users[0].user_wallet.loan_balance : 'N/A'}}</b-badge></div>
                        </div>
                         </td>
                      <td v-else>N/A</td>

                    <td class="padding-5px-right">
                        <div class="row">
                            <div class="col-xs-4">{{agent.first_name}} {{agent.last_name}}</div>
                        </div>
                        <div class="row">
                            <div class="col-xs-4">{{agent.phone_code}} {{agent.phone_number}}</div>
                        </div>

                    </td>
                      <td class="padding-5px-right" v-if="agent.agency_information[0]!=undefined">
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].management_full_name==null ? 'N/A' : agent.agency_information[0].management_full_name}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].management_phone_number==null ? 'N/A' : agent.agency_information[0].management_phone_number}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].management_email==null ? 'N/A' : agent.agency_information[0].management_email}}</div>
                          </div>
                      </td>
                      <td v-else>N/A</td>
                      <td  class="padding-5px-right"   v-if="agent.agency_information[0]!=undefined">
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].city==null ? 'N/A' : agent.agency_information[0].city}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4">{{agent.agency_information[0].address==null ? 'N/A' : agent.agency_information[0].address}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"> {{agent.agency_information[0].country == null ? 'N/A' : agent.agency_information[0].country}}</div>
                          </div>
                      </td>
                      <td v-else>N/A</td>
<!--                      <td v-if="agent.users[0].user_wallet!=null">{{ agent.users[0].user_wallet.main_balance }}</td>-->
<!--                      <td v-else>0</td>-->
<!--                      <td v-if="agent.users[0].user_wallet!=null">{{ agent.users[0].user_wallet.loan_balance }}</td>-->
<!--                      <td v-else>0</td>-->
<!--                      <td v-if="agent.users!=undefined">{{agent.users[0].status}}</td>-->
<!--                      <td v-else >null</td>-->
                     <td>
                         <b-dropdown dropright>
                             <template v-slot:button-content>
                                 Action
                                 <i class="mdi mdi-chevron-down"></i>
                             </template>
                             <b-dropdown-item><b-button class="btn btn-primary btn-sm"  v-b-modal.modal-lg variant="primary" @click.prevent="getAgentDetails(agent)">Details</b-button></b-dropdown-item>
                             <b-dropdown-item><router-link :to="{ name: 'agent_update', params: {type:'approve',uuid: agent.uuid}}" class="btn btn-primary btn-sm"> Edit</router-link></b-dropdown-item>
                             <b-dropdown-item><button v-if="agent.users[0].status=='active'" class="btn btn-primary btn-sm" @click.prevent="userStatusWarning(agent.users[0].uuid)">Deactivate</button><button style="width:100%" v-else class="btn btn-primary btn-sm" @click.prevent="userStatusWarning(agent.users[0].uuid)">Activate</button></b-dropdown-item>
                         </b-dropdown>
                     </td>
<!--                    <td><b-button class="btn btn-primary btn-small"  v-b-modal.modal-lg variant="primary" @click.prevent="getAgentDetails(agent)">Details</b-button></td>-->
<!--                      <td><router-link :to="{ name: 'agent_update', params: {type:'approve',uuid: agent.uuid}}" class="btn btn-primary btn-small"> Edit</router-link></td>-->
<!--                      <td  align='center'><button v-if="agent.users[0].status=='active'" class="btn btn-primary btn-small" @click.prevent="userStatusWarning(agent.users[0].uuid)">Deactivate</button><button style="width:100%" v-else class="btn btn-primary btn-small" @click.prevent="userStatusWarning(agent.users[0].uuid)">Activate</button></td>-->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
table>tr>td{
    width:30%;
    height:30px;
}
.margin-5px{
    margin-right: 5px;
}
.width-20px{
    table-layout: fixed;
    width: 20px;
}
.padding-5px{
    padding-right: 3%;
    padding-left: 3%;
}
/*.padding-5px-right{*/
/*    word-break: break-all;*/
/*    overflow: auto;*/
/*}*/
.table-responsive img{
    width:60px;
}
table>tr>td:nth-child(odd) {
    font-weight: 600;
}
</style>
